export const ERRORS = {
  limit: "limit_reached",
  access: "no_access",
};
